import { InputGroup, InputLeftElement } from "@chakra-ui/react";
import StyledInput from "./StyledInput";

function StyledCurrencyInput(props) {
  return (
    <InputGroup>
      <InputLeftElement
        pointerEvents="none"
        color="gray.500"
        fontSize="1.2em"
        children="£"
        style={{ borderRight: "1px solid #999" }}
        height="3rem"
      />
      <StyledInput pl="50px" type="number" placeholder="EG: 10000" {...props} />
    </InputGroup>
  );
}

export default StyledCurrencyInput;
